import React, { useState } from "react"
import {
  ServicesContainer,
  Title,
  Accordion,
  AccordionColumn,
  ServicesDetails,
  ServiceSummary,
  ServiceIcon,
  ServiceContent,
} from "./style"

const Services = ({ title, services }) => {
  const [open, setOpen] = useState({})

  const midIndex = Math.ceil(services.length / 2)
  const leftColumnServices = services.slice(0, midIndex)
  const rightColumnServices = services.slice(midIndex)

  const handleClick = index => () => {
    setOpen(prevOpen => ({ ...prevOpen, [index]: !prevOpen[index] }))
  }

  return (
    <ServicesContainer>
      <Title>{title}</Title>
      <Accordion>
        <AccordionColumn>
          {leftColumnServices.map((service, index) => {
            return (
              <ServicesDetails key={index} isOpen={open[`first-${index}`]}>
                <ServiceSummary onClick={handleClick(`first-${index}`)}>
                  <ServiceIcon name="arrow_down" />
                  <p>{service.title}</p>
                </ServiceSummary>
                <ServiceContent
                  dangerouslySetInnerHTML={{
                    __html: service.description,
                  }}
                  isOpen={open[`first-${index}`]}
                />
              </ServicesDetails>
            )
          })}
        </AccordionColumn>
        <AccordionColumn>
          {rightColumnServices.map((service, index) => (
            <ServicesDetails key={index} isOpen={open[`second-${index}`]}>
              <ServiceSummary onClick={handleClick(`second-${index}`)}>
                <ServiceIcon name="arrow_down" />
                <p>{service.title}</p>
              </ServiceSummary>
              <ServiceContent
                dangerouslySetInnerHTML={{
                  __html: service.description,
                }}
                isOpen={open[`second-${index}`]}
              />
            </ServicesDetails>
          ))}
        </AccordionColumn>
      </Accordion>
    </ServicesContainer>
  )
}

export default Services
